export const bannerMinHeight = 50;
